import en from "./en";
import de from "./de";
import hr from "./hr";

export const DICTS = { en, de, hr };

export const DEFAULT_LANG = "de";
export const STORAGE_KEY = "learnos_lang";

// Ordered list used by the language switcher. Add a new entry here + a dict file
// to support another language — nothing else needs to change.
export const LANGUAGES = [
    { code: "de", label: "Deutsch", short: "DE", flag: "🇩🇪" },
    { code: "en", label: "English", short: "EN", flag: "🇬🇧" },
    { code: "hr", label: "Hrvatski", short: "HR", flag: "🇭🇷" },
];

export const SUPPORTED = LANGUAGES.map((l) => l.code);

// Language NAME passed to the backend so AI prompts generate in that language.
export const AI_LANG_NAMES = { de: "German", en: "English", hr: "Croatian" };

// Resolution order: saved selection -> browser language -> German fallback.
export const resolveInitialLang = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved && SUPPORTED.includes(saved)) return saved;
    } catch (e) { /* ignore */ }
    try {
        const navLangs = navigator.languages && navigator.languages.length
            ? navigator.languages
            : [navigator.language || ""];
        for (const l of navLangs) {
            const code = String(l).slice(0, 2).toLowerCase();
            if (SUPPORTED.includes(code)) return code;
        }
    } catch (e) { /* ignore */ }
    return DEFAULT_LANG;
};
